import { render, staticRenderFns } from "./BarCode.vue?vue&type=template&id=0d946fc5&"
import script from "./BarCode.vue?vue&type=script&lang=ts&"
export * from "./BarCode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports